import {
  confirmable,
  createConfirmation,
  type ConfirmDialogProps,
} from "react-confirm";

import MultipleChoiceModal from "../../../../../components/Modals/MultipleChoiceModal";

type Message = { title: string; description: string };
type Args = Message & { canRetry: boolean };

export function UnassignedPropertiesPrompt({
  show,
  proceed,
  title,
  description,
  canRetry,
}: ConfirmDialogProps<Args, boolean>) {
  return (
    <div className="[&_.rounded-full]:cursor-pointer [&_.rounded-full]:select-none">
      <MultipleChoiceModal
        open={show}
        closeModal={() => proceed(false)}
        title={title}
        subtitle={description}
        options={[
          {
            color: "blue",
            label: canRetry ? "Yes, add them to routes" : "OK",
            onClick: () => proceed(true),
          },
          ...(canRetry
            ? [
                {
                  color: "blue",
                  label: "No, I'll place them",
                  onClick: () => proceed(false),
                },
              ]
            : []),
        ]}
      />
    </div>
  );
}

const confirm = createConfirmation<Args, boolean>(
  confirmable<Args, boolean>(UnassignedPropertiesPrompt),
);

export function confirmUnassignedProperties(
  message: Message,
  canRetry: boolean,
): Promise<boolean> {
  return confirm({ ...message, canRetry });
}
